import { ref } from 'vue-demi';
import NNQ from '@futuweb/tool-nn/dist/nnq';
import * as browser from '@futuweb/tool-browser';

/**
 * NN WebView JSBridge 类型定义
 */
interface NNWebViewJSBridge {
  callHandler: (
    method: string,
    params: Record<string, unknown>,
    callback: (res: string) => void,
  ) => void;
}

/**
 * 扩展 Window 类型以包含 NNWebViewJSBridge
 */
interface WindowWithNNBridge extends Window {
  NNWebViewJSBridge?: NNWebViewJSBridge;
}

/**
 * 获取 app 配置的涨跌色，一般用来作为外层容器的 classname 来控制涨跌色类型
 * @param followApp 是否跟随 app 配置涨跌色，false 时直接返回第二个参数
 * @param defaultRateColor 默认涨跌色，客户端不支持的情况下返回默认值
 * @returns 返回 quotes-color-[0-3]
 */
export const useRateClsByApp = (followApp: boolean, defaultRateColor = 0) => {
  const rateColorCls = ref(`quotes-color-${defaultRateColor}`);

  if (!followApp) {
    return rateColorCls;
  }

  // 客户端不支持的话，直接返回默认值，安卓和ios刚好同版本发布 12.43.8908开始支持
  if (
    !browser.isMobileNN() ||
    !browser.laterThanClient({ isXYZFormat: true, ver: '12.43.8908' })
  ) {
    return rateColorCls;
  }

  NNQ.initBridge({}, () => {
    const windowWithBridge = window as WindowWithNNBridge;
    windowWithBridge.NNWebViewJSBridge?.callHandler(
      'getUpDownType',
      {},
      (res: string) => {
        try {
          const ret = JSON.parse(res) as { result: number; data?: number };
          if (ret && ret.result === 0) {
            const rate = Number(ret.data || 0);
            if (rate === 2) {
              rateColorCls.value = 'quotes-color-0';
            } else if (rate === 3) {
              rateColorCls.value = 'quotes-color-1';
            }
            // data:涨跌色，0红涨绿跌，1绿涨红跌，2色盲色涨色（粉涨绿跌），3色盲色跌色（绿涨粉跌）
          }
        } catch (e) {
          console.error(e);
        }
      },
    );
  });

  return rateColorCls;
};
